<script lang="ts">
	import { format } from 'svelte-i18n';

	import {
		control_bluetooth_device_ios,
		control_bluetooth_motion_sensitivity_ios,
	} from 'src/services/native_container_requests_ios';
	import {
		control_bluetooth_device_android,
		control_bluetooth_motion_sensitivity_android,
	} from 'src/services/native_container_requests_android';

	import { app, os } from 'src/stores/session/native-bridge';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import { bulkUpdate } from '../ApplicationSettings/app_settings_helper';

	import { Radio, Button, Text, Stack, toast } from '@Shelly/shelly-design-system';
	import { BLU_STATUS } from 'src/types/requests/settings/blu_status';

	export let device;

	let motionSensitivity = device?.motionSensitivity + '' ? device.motionSensitivity + '' : '0';
	let initialized = false;
	let options = [
		{
			translation_key: 'option_low_sensitivity',
			translation_default: 'low sensitivity',
		},
		{
			translation_key: 'option_moderate_sensitivity',
			translation_default: 'moderate sensitivity',
		},
		{
			translation_key: 'option_high_sensitivity',
			translation_default: 'high sensitivity',
		},
	];

	const setMotionSensitivity = () => {
		if ($controlBleDevice.connectionState === 2) {
			$os === 'IOS'
				? control_bluetooth_motion_sensitivity_ios(device.id, motionSensitivity)
				: control_bluetooth_motion_sensitivity_android(device.id, motionSensitivity);

			bulkUpdate(device.id, { motionSensitivity });
		} else {
			$os === 'IOS'
				? control_bluetooth_device_ios(device.id, 'connect')
				: control_bluetooth_device_android(device.id, 'connect');
		}
	};

	$: switch ($controlBleDevice.currentStatusIndex) {
		// after receiving one of the statuses below remove the initialized state
		case BLU_STATUS.UNHANDLED_STATE:
		case BLU_STATUS.BUTTON_PRESS_REQUIRED:
		case BLU_STATUS.CONNECT_TO_DEVICE:
		case BLU_STATUS.DISCONNECT_FROM_DEVICE:
			initialized = false;
			break;
		// after receiving one of the statuses below add the initialized state
		case BLU_STATUS.DEVICE_OTA_AVAILABLE:
		case BLU_STATUS.DEVICE_OTA_REQUIRED:
		case BLU_STATUS.DEVICE_PROCESSED:
		case BLU_STATUS.BEACON_ENABLED:
		case BLU_STATUS.BEACON_DISABLED:
		case BLU_STATUS.MOTION_LED_ENABLED:
		case BLU_STATUS.MOTION_LED_DISABLED:
		case BLU_STATUS.BLIND_TIME_SET:
		case BLU_STATUS.SENSITIVITY_SET:
			initialized = true;
			break;
		default:
			break;
	}
</script>

<Text styleType="body-small" class="mb-s">
	{$format('text_motion_sensitivity', {
		default: 'Set the motion sensitivity of the device.',
	})}
</Text>

<Stack gap="s" class="mb-m">
	{#each options as option, index}
		<Radio bind:selected={motionSensitivity} size="m" value={'' + index} id="radio-aaa6kbd"
			>{$format(option.translation_key, {
				default: option.translation_default,
			})}</Radio
		>
	{/each}
</Stack>

<Button disabled={!initialized || !$app} size="m" width="full" on:click={setMotionSensitivity}>
	{$format('button_save', { default: 'Save' })}
</Button>
